<template>
  <div class="flex-start-md">
    <p>
      <i18n-t keypath="NotificationsComponent.NextTierNotAvailableForSeatUpgrade" tag="span" scope="global">
        <template #activeDevices>
          {{ seatData.activeDevices }}
        </template>
        <template #planDevices>
          {{ seatData.planDevices }}
        </template>
        <template #overDevices>
          {{ seatData.overDevices }}
        </template>
        <template #myAccountLink>
          <button type="button" class="inline-btn-link" @click="goToSecurityPage()">{{ t("Brand.myAccount") }}</button>
        </template>
      </i18n-t>
    </p>
  </div>
</template>

<script setup lang="ts">
import { PropType, computed } from "vue";
import { INotification } from "@/stores/notificationsInterfaces";
import { t } from "@/i18n";
import { goToSecurityPage } from "./notificationsHelper";

const props = defineProps({
  notification: {
    type: Object as PropType<INotification>,
    required: true,
  },
});

const seatData = computed(() => {
  const params = props.notification?.params;
  // Use new descriptive names with fallback to legacy digit properties
  const activeDevices = params?.seatEnforcementParams?.activeDevices ?? 0;
  const planDevices = params?.seatEnforcementParams?.planDevices ?? 0;

  return {
    activeDevices: activeDevices || "",
    planDevices: planDevices || "",
    overDevices: Math.max(0, activeDevices - planDevices),
  };
});
</script>
